import CustomFilterSelect from "./CustomFilterSelect";
const FilterPaymentFrequency = (props: any) => {
  return (
    <CustomFilterSelect
      source="paymentfrequency"
      label="Payment Frequency"
      choices={[
        { id: "Monthly", name: "Monthly" },
        { id: "Monthly End", name: "Monthly End" },
        { id: "Semimonthly", name: "Semimonthly" },
        { id: "Weekly", name: "Weekly" },
        { id: "Bi-Weekly", name: "Bi-Weekly" },
      ]}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterPaymentFrequency;
